import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import { createBootstrap } from 'bootstrap-vue-next';
import 'vue3-toastify/dist/index.css';
import router from './router';

import { OhVueIcon, addIcons } from "oh-vue-icons"
import { BiTelephoneFill, BiGlobe, BiEnvelopeFill, BiGeoAltFill, BiInstagram } from "oh-vue-icons/icons/bi"

addIcons(BiTelephoneFill, BiGlobe, BiEnvelopeFill, BiGeoAltFill, BiInstagram)

const app = createApp(App);
const bootstrap = createBootstrap();

app.use(bootstrap);
app.use(router);
app.component("v-icon", OhVueIcon)
app.mount('#app');
